interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "AMD";
};

const AMD: Currency = Object.freeze({
  "displayName": "Armenian Dram",
  "numericCode": 51,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "AMD",
  "symbol": "֏"
});

export { AMD };
